import React from "react";
import { PaymentMethod } from "./enum";
import { PaymentWrapperView } from "../../enum";
import { PaymentWrapperHeaderPropTypes } from "./types";
import { useResendInvoicePayerPaymentReminder } from "./dataloader";

export function usePaymentWrapperHeaderService({
  resendInvoicePaymentReminderSuccessHandler,
  ...props
}: PaymentWrapperHeaderPropTypes) {
  const { mutateAsync: resendInvoicePaymentReminder } = useResendInvoicePayerPaymentReminder(
    props.registrationParticipantId,
    props.invoicePaymentRequestId
  );

  const applicablePaymentMethod = React.useMemo(() => {
    if (props.invoicePaymentEnabled && props.offlinePaymentEnabled) return PaymentMethod.BOTH;
    else if (props.invoicePaymentEnabled) return PaymentMethod.INVOICE_PAYMENT;
    else if (props.offlinePaymentEnabled) return PaymentMethod.OFFLINE_PAYMENT;
    else return PaymentMethod.NONE;
  }, [props.invoicePaymentEnabled, props.offlinePaymentEnabled]);

  const updateInvoicePaymentRequestClickHandler = React.useCallback(() => {
    props.dispatch.setShowResendInvoicePaymentRequestAction(true);
    props.dispatch.setPaymentWrapperView(PaymentWrapperView.REQUEST_PAYMENT);
  }, [props.dispatch]);

  const resendInvoicePaymentRequestClickHandler = React.useCallback(async () => {
    try {
      await resendInvoicePaymentReminder({});
      resendInvoicePaymentReminderSuccessHandler?.();
    } catch (e) {}
  }, [resendInvoicePaymentReminder, resendInvoicePaymentReminderSuccessHandler]);

  return {
    applicablePaymentMethod,
    updateInvoicePaymentRequestClickHandler,
    resendInvoicePaymentRequestClickHandler
  };
}
